import { IFilterItemV2 } from "#src/commonV2/Table/Filter/types";
import {
  PaymentMethodValue,
  SolutionStatusValue,
} from "#src/services/payment/enum";
import { PaymentMethodEnum, SolutionStatusEnum } from "./enum";
import i18next from "i18next";

export const solutionStatusItems: IFilterItemV2[] = [
  {
    key: SolutionStatusEnum.ACTIVE,
    value: SolutionStatusValue.ACTIVE,
    getLabel: () => i18next.t("filter.serviceStatus.active"),
  },
  {
    key: SolutionStatusEnum.EXPIRING,
    value: SolutionStatusValue.EXPIRING,
    getLabel: () => i18next.t("filter.serviceStatus.expiring"),
  },
  {
    key: SolutionStatusEnum.EXPIRED,
    value: SolutionStatusValue.EXPIRED,
    getLabel: () => i18next.t("filter.serviceStatus.expired"),
  },
];

export const paymentMethodItems: IFilterItemV2[] = [
  {
    key: PaymentMethodEnum.BANKING,
    value: PaymentMethodValue.BANKING,
    getLabel: () => i18next.t("filter.paymentMethod.banking"),
  },
  {
    key: PaymentMethodEnum.CARD,
    value: PaymentMethodValue.CARD,
    getLabel: () => i18next.t("filter.paymentMethod.card"),
  },
];
